module.exports = __webpack_public_path__ + "img/new-people-employee-support.bdd7a8c9.png";